import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class SiteconfigService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allsiteconfig(): Promise<any> {
        return this.httpmanagerService.HttpGet('siteconfig', "").then(function (data) {
            return data.data;
        });
    }
    ikeyword(data){
        return this.httpmanagerService.HttpPost('siteconfig', JSON.stringify(data), "").then(function (data) {
            return data;
        });
    }
    usiteconfig(id, data): Promise<any> {
        return this.httpmanagerService.HttpPut('siteconfig', JSON.stringify(data), id).then(function (data) {
            return data;
        });
    }
    dkeyword(id) :  Promise<any> {
        return this.httpmanagerService.HttpDelete('siteconfig', id).then(function (data) {
            return data;
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/siteconfig/siteconfig.service.ts